// src/pages/Automations/components/AutomationHeader.jsx
// Header component with title, stats, and Template Basics button (Light theme)

import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Settings, Shield } from 'lucide-react';

export function AutomationHeader({ totalEnabled, totalTriggers, onOpenTemplateBasics, isFounder = false }) {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-amber-100 rounded-xl">
            <Zap className="w-8 h-8 text-amber-600" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
              Automations
            </h1>
            <p className="text-gray-500 mt-1">
              Automated client outreach
              <span className="ml-2 px-2 py-0.5 bg-green-100 text-green-700 text-sm font-semibold rounded-full">
                {totalEnabled} / {totalTriggers} Active
              </span>
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {/* Command Center - Founder Only */}
          {isFounder && (
            <Link
              to="/admin/automations"
              className="flex items-center gap-2 px-5 py-2.5 bg-red-500 hover:bg-red-600 text-white font-bold rounded-xl transition-colors shadow-md"
            >
              <Shield className="w-5 h-5" />
              Command Center
            </Link>
          )}

          <button
            onClick={onOpenTemplateBasics}
            className="flex items-center gap-2 px-5 py-2.5 bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-xl transition-colors shadow-md"
          >
            <Settings className="w-5 h-5" />
            Template Basics
          </button>
        </div>
      </div>
    </div>
  );
}

export default AutomationHeader;
